import { FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { act } from "@/lib/hooks";
import { fmt, fdate } from "@/lib/api";
import { portalApi, usePortalLoad, downloadWith } from "@/lib/portalApi";
import { PageHeader, Section, StatusBadge } from "@/components/common";
import { FileUploadButton } from "@/components/FileUploadButton";
import { ArtworkList } from "./PortalJob";

export default function PortalQuotes() {
  const [d, reload] = usePortalLoad("/quotes");
  if (!d) return null;
  const attach = (q) => async (upload_id) => { if (await act(() => portalApi.post("/artwork", { upload_id, target_type: "quote", target_id: q.id }), "Artwork uploaded")) reload(); };
  return (
    <>
      <PageHeader title="Your quotes" subtitle="Download quotations and send artwork early to speed things up." />
      {d.quotes.length === 0 && <p className="po-card p-6 text-sm text-slate-400">No quotes yet.</p>}
      {d.quotes.map((q) => (
        <Section key={q.id} testId={`portal-quote-${q.number}`} title={<span>{q.number} · {q.title}</span>}
          action={<div className="flex flex-wrap gap-2">
            <Button size="sm" variant="outline" data-testid={`portal-quote-pdf-${q.number}`} onClick={() => downloadWith(portalApi, `/quotes/${q.id}/pdf`, `${q.number}.pdf`, true)}><FileDown className="mr-1 h-4 w-4" />PDF</Button>
            <FileUploadButton client={portalApi} base="" onUploaded={attach(q)} label="Upload artwork" testId={`portal-quote-upload-${q.number}`} />
          </div>}>
          <div className="flex flex-wrap items-center gap-4 border-b border-slate-100 px-5 py-3 text-sm">
            <StatusBadge status={q.status} testId={`portal-quote-status-${q.number}`} />
            <span className="tabular-nums font-semibold">{fmt(q.total, d.currency)}</span>
            <span className="text-slate-500">Version {q.version}{q.valid_until && ` · valid until ${fdate(q.valid_until)}`}</span>
          </div>
          {q.revisions?.length > 0 && <div className="border-b border-slate-100 px-5 py-3" data-testid={`portal-quote-revisions-${q.number}`}><div className="mb-1 text-xs font-semibold uppercase text-slate-500">Revision history</div>
            <ul className="space-y-1 text-sm">{q.revisions.map((r) => <li key={r.version} className="flex flex-wrap items-center gap-3"><span>Version {r.version}</span><span className="text-slate-500">issued {fdate(r.issued_at)}</span>{r.total != null && <span className="tabular-nums text-slate-500">{fmt(r.total, d.currency)}</span>}
              <button type="button" className="text-[#13294B] underline" data-testid={`portal-quote-rev-pdf-${q.number}-v${r.version}`} onClick={() => downloadWith(portalApi, `/quotes/${q.id}/pdf?version=${r.version}`, `${q.number}-v${r.version}.pdf`, true)}>View PDF</button></li>)}</ul></div>}
          <ArtworkList rows={q.artwork} client={portalApi} base="" testId={`portal-quote-artwork-${q.number}`} />
        </Section>
      ))}
    </>
  );
}
